import { useState } from "react";
import { faqs } from "@/mocks/siteData";
import SectionHeader from "./SectionHeader";

export default function FaqSection() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="relative scroll-mt-20 py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <SectionHeader
          eyebrow="常见问题"
          title="你可能想知道"
          desc="关于内容来源、更新频率与投稿合作等高频问题，这里给出最直接的答复。"
          center
        />

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className={`rounded-xl border bg-background-100 transition-colors ${
                  isOpen ? "border-primary-300" : "border-background-200 hover:border-background-300"
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                  aria-expanded={isOpen}
                >
                  <h3 className={`font-heading font-bold text-base md:text-lg ${isOpen ? "text-primary-700" : "text-foreground-950"}`}>
                    {f.q}
                  </h3>
                  <span
                    className={`flex items-center justify-center w-8 h-8 rounded-full shrink-0 transition-all duration-300 ${
                      isOpen ? "bg-primary-500 text-background-50 rotate-45" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className="ri-add-line text-lg w-5 h-5 flex items-center justify-center"></i>
                  </span>
                </button>
                <div
                  className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-96" : "max-h-0"}`}
                >
                  <p className="px-5 pb-5 text-sm text-foreground-600 leading-relaxed">{f.a}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}